/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import teaserImage from "../../assets/img/teaser/Legalbird_Teaser_Main.jpg";
import { scrollToAnchor } from "../../theme/commonStyle";

const teaserWithCardsStyle = {
  teaser: {
    minHeight: "60vh",
    overflow: "hidden",
    backgroundPositionX: "center",
    backgroundPositionY: "top",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "space-around",
    flexWrap: "wrap",
    backgroundImage: "url(" + teaserImage + ")",
  },
  gridItemText: {
    textAlign: "center",
    marginBottom: "1rem",
  },
  gridContainer: {
    paddingBottom: "20px",
  },
  marginTop: {
    marginTop: "5.25rem",
  },
  buttonContainer: {
    textAlign: "center",
  },
  startButton: {
    marginTop: "20px",
    width: { xs: "100%", sm: "40%" },
  },
  scrollToAnchor,
};

export default teaserWithCardsStyle;
